import { render } from "./GetInvolvedHero.vue?vue&type=template&id=5e1ed6d6"
import script from "./GetInvolvedHero.vue?vue&type=script&lang=js"
export * from "./GetInvolvedHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__